import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from 'resources/resources';
const language = document.cookie.replace(/(?:(?:^|.*;\s*)lg\s*=\s*([^;]*).*$)|^.*$/, '$1');

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  resources,
  lng: language ? language : 'ru',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
